<div class="provision-panel">
    <div class="provision-fields">
        <div class="form-group provision-field">
            <label for="txtProvisionLibrary">Provision library</label>
            <input id="txtProvisionLibrary" type="text" class="form-control" autocomplete="off" placeholder="Provision Library"
                [attr.aria-describedby]="provisionLibraryMessage ? 'provisionLibraryHelp' : null"
                [disabled]="provisionSaving || provisionLoading"
                [(ngModel)]="provisionUserName" (blur)="onProvisionLibraryCommit()" (keydown.enter)="onProvisionLibraryCommit()">
            <p *ngIf="provisionLibraryMessage" id="provisionLibraryHelp" role="status">{{ provisionLibraryMessage }}</p>
        </div>
        <div class="form-group provision-field">
            <label id="lblProvisionName" for="txtProvisionName">Provision name</label>
            <div class="provision-combobox" [class.provision-combobox--open]="provisionListOpen">
                <input #provisionNameInput id="txtProvisionName" type="text" class="form-control provision-combobox__input"
                    role="combobox" aria-autocomplete="list" aria-controls="lstProvisionNames"
                    [attr.aria-expanded]="provisionListOpen"
                    [attr.aria-activedescendant]="activeProvisionIndex >= 0 ? 'provision-option-' + activeProvisionIndex : null"
                    autocomplete="off" maxlength="25" placeholder="Provision Name"
                    [disabled]="provisionSaving || provisionLoading"
                    [(ngModel)]="provisionName" (ngModelChange)="onProvisionNameInput()"
                    (focus)="openProvisionList()" (click)="openProvisionList()" (blur)="closeProvisionList()"
                    (keydown)="onProvisionNameKeydown($event)">
                <button type="button" class="provision-combobox__toggle" tabindex="-1" aria-hidden="true"
                    [disabled]="provisionSaving || provisionLoading || (userProvisions.length === 0 && !userProvisionsLoading)"
                    (mousedown)="$event.preventDefault(); provisionNameInput.focus(); toggleProvisionList()">
                    <tds-icon name="chevron_down" size="16px"></tds-icon>
                </button>
                <ul *ngIf="provisionListOpen" id="lstProvisionNames" class="provision-combobox__list" role="listbox"
                    aria-labelledby="lblProvisionName">
                    <li *ngIf="userProvisionsLoading" class="provision-combobox__status" role="option" aria-disabled="true">Loading provisions...</li>
                    <li *ngFor="let item of filteredUserProvisions; let i = index" role="option" class="provision-combobox__option"
                        [id]="'provision-option-' + i" [class.active]="i === activeProvisionIndex"
                        [attr.aria-selected]="i === activeProvisionIndex"
                        (mousedown)="$event.preventDefault()" (click)="selectProvision(item)">{{ item.ProvisionName }}</li>
                    <li *ngIf="!userProvisionsLoading && filteredUserProvisions.length === 0" class="provision-combobox__status"
                        role="option" aria-disabled="true">No matching provisions</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="form-group provision-period" *ngIf="provision.Name">
        <label for="txtPDVersion">Part period <span *ngIf="provisionService.hasPartPeriodChanges()">· Changed</span></label>
        <input id="txtPDVersion" type="text" class="form-control" placeholder="YYYY.MM.P"
            [disabled]="provisionSaving || provisionLoading" [ngModel]="partPeriodInput"
            (ngModelChange)="setPartPeriod($event)" [attr.aria-invalid]="invalidPartPeriod"
            aria-describedby="partPeriodHelp">
        <p id="partPeriodHelp" [class.provision-period__error]="invalidPartPeriod">
            {{ invalidPartPeriod ? 'Enter a valid part period, for example 2026.11.1.' : 'Saved with the provision. Used for analysis and execution choices.' }}
        </p>
        <p *ngIf="provisionService.hasPartPeriodChanges()">Previous: {{ provisionService.savedPartPeriod || 'Not set' }}</p>
    </div>

    <p *ngIf="provisionLoading" role="status">Loading provision...</p>

    <conversion-alert *ngIf="showSaveConfirmation" [type]="'alert-success'" [header]="''"
        [message]="'Your changes have been saved.'" (close)="provisionSaved = false"></conversion-alert>

    <conversion-alert *ngIf="provision.Name && !provisionDetailsAvailable" [type]="'alert-info'" [header]="''"
        [message]="'Part period and descriptions are unavailable. Enter a part period above before analyzing.'"></conversion-alert>

    <conversion-alert *ngIf="provisionSaveFailed" [type]="'alert-warning'" [header]="''"
        [message]="provisionSaveMessage" [dismissible]="false"></conversion-alert>

    <div *ngIf="userProvisionsLoadFailed">
        <conversion-alert [type]="'alert-warning'" [header]="''" [message]="userProvisionsMessage" [dismissible]="false"></conversion-alert>
        <button type="button" class="btn btn-default" [disabled]="userProvisionsLoading" (click)="getUserProvisions()">Try loading the list again</button>
    </div>

    <conversion-alert *ngIf="noProductType" [type]="'alert-warning'" [header]="''" [message]="'There is no product type found for this provision.'"></conversion-alert>

    <div *ngIf="provisionLoadFailed">
        <conversion-alert [type]="'alert-warning'" [header]="''" [message]="provisionLoadMessage" [dismissible]="false"></conversion-alert>
        <button type="button" class="btn btn-default" [disabled]="provisionLoading || provisionSaving" (click)="getProvision(provisionSaved)">Try loading the provision again</button>
    </div>

</div>
